module.exports = __webpack_public_path__ + "img/40.99b2faf8.png";